import React, {useContext, useEffect, useState} from 'react';
import {BROKER, VENDOR} from "../../services/constants/CompanyType";
import {ADMIN, BILLING, MARKETING, SALES} from "../../services/constants/VendorAccountPrivilegues";
import {
    SEARCH_NAV,
    PROJECTS_NAV,
    ADMIN_NAV,
    SALES_NAV,
    MARKETING_NAV,
    ACCOUNTING_NAV, HOME_NAV, WEBINARS_NAV
} from "../../services/constants/MenuItems";
import {AuthContext} from "../../context/AuthContext";
import LogoAvatar from "../Item/LogoAvatar";
import NavLink from "../Navigation/NavLink";
import NavMessaging from "../Navigation/NavMessaging";
import UserMenu from "../Navigation/UserMenu";
import {Link, useLocation} from "react-router-dom";
import NavReminders from "../Navigation/NavReminders";
import CardExpiryNotification from "./Notifications/CardExpiryNotifications";
import NavDropDown from "./NavDropDown";

const APP_BASE_URL = process.env.REACT_APP_APP_BASE_URL;

const Header = ({newMessages}) => {
    const {baseUrl, company, notifications, hasProjectAccess, ...user} = useContext(AuthContext);
    let logoLink;
    let tempMenu = [];

    switch (user.type) {
        case BROKER:
            logoLink = `${baseUrl}/vendor/search`;
            tempMenu = [
                {
                    href: `${baseUrl}/vendor/search`,
                    text: SEARCH_NAV,
                },
            ];

            if (![BILLING].includes(company.privileges)) {
                if (hasProjectAccess === true) {
                    tempMenu.push(
                        {
                            href: "",
                            text: PROJECTS_NAV,
                            subMenuItems: [{
                                href: `${baseUrl}/project/list`,
                                text: "RFP Projects",
                            }, {
                                href: `${process.env.REACT_APP_APP_BASE_URL}/broker/project/rfi/list`,
                                text: "RFI Projects",
                            },]
                        },
                    );
                } else
                    tempMenu.push(
                        {
                            href: `${baseUrl}/project/list`,
                            text: PROJECTS_NAV,
                        },
                    );
            }

            if (company.has_mav) {
                tempMenu.push(
                    {
                        href: `/broker/webinars`,
                        text: WEBINARS_NAV,
                    },
                );
            }
            break;
        case VENDOR:
            logoLink = `${baseUrl}/admin`;
            tempMenu = [];

            if (company?.has_dashboard) {
                tempMenu.push({href: `/vendor/${company.slug}/dashboard`, text: HOME_NAV});
                logoLink = `/vendor/${company.slug}/dashboard`;
            }

            if ([ADMIN].includes(company.privileges) || user.is_primary) {
                tempMenu.push({href: `${baseUrl}/admin`, text: ADMIN_NAV});
            }
            if ([ADMIN, SALES].includes(company.privileges) || user.is_primary) {
                tempMenu.push({href: `${baseUrl}/sales`, text: SALES_NAV});
            }
            if ([ADMIN, MARKETING].includes(company.privileges) || user.is_primary) {
                tempMenu.push({href: `${baseUrl}/marketing`, text: MARKETING_NAV});
            }
            if (([ADMIN, BILLING].includes(company.privileges) || user.is_primary)
                && (company?.is_preferred || company?.previous_preferred || company?.select_preferred)) {
                tempMenu.push({href: `${APP_BASE_URL}/payment/payment_history`, text: ACCOUNTING_NAV});
            }
            break;
        default:
            tempMenu = [];
    }


    const [headerMenu, setHeaderMenu] = useState(tempMenu);
    const location = useLocation();
    let companyLogo = company.logo ? `fit/600x300/${company.logo}` : 'svg/broker/shortlister-logo-wrap.svg';
    const card_expires = notifications?.find?.(item => item.type === 'card_expires');

    const changeActiveMenu = () => {
        setHeaderMenu(headerMenu.map((item) => {
            if (item.href.includes(location.pathname)) {
                return {...item, additionalListClasses: 'sl-current-link'}
            } else {
                return {...item, additionalListClasses: ''}
            }
        }));
    };

    useEffect(() => {
            changeActiveMenu();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [location.pathname]);

    return (
        <>

            <header
                className="sl-header sl-flex sl-flex-col">

                {card_expires && <CardExpiryNotification type={card_expires.value}/>}

                <div
                    className=" sl-border-bottom sl-bg-white sl-min-h-18 sl-flex sl-justify-center sl-gap-2-point-5 sl-items-center">
                    <div className="sl-container">

                        <div className="sl-row sl-flex sl-justify-between sl-items-center">

                            <Link className="sl-col-span-2" to={logoLink}>
                                <LogoAvatar logo={companyLogo}
                                            avatarClass="sl-max-h-12 sl-max-w-55 sl-w-full sl-rounded-none"
                                            resize={true} header={company.logo === null}
                                            slug={company.slug}/>
                            </Link>

                            <nav className="sl-col-span-5 sl-navbar sl-flex-1">
                                <ul className="sl-flex sl-gap-2">
                                    {headerMenu.map((item, index) => (
                                        item.subMenuItems ? (
                                                <NavDropDown menuItems={item.subMenuItems} title={item.text}/>) :
                                            <NavLink key={index} href={item.href} text={item.text}
                                                     listClass={`sl-font sl-font-medium sl-text-md sl-py-8 sl-px-12 ${item.additionalListClasses}`}
                                                     linkClass={`sl-btn sl-btn-link-gray sl-text-gray-base sl-no-underline`}
                                            />
                                    ))}


                                </ul>
                            </nav>

                            <span
                                className="sl-col-span-2 sl-user-menu sl-justify-self-end sl-flex">
                        <NavMessaging newMessageCount={newMessages}/>
                                {user.type === BROKER && <NavReminders/>}
                                <UserMenu userData={user} baseUrl={baseUrl} company={company}/>
                    </span>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;
